<template>
  <div
    v-if="isQzTrayInstalled && isPrinterConfigured"
    class="d-inline"
    @click="sendJobToPrinter"
  >
    <slot name="activator" />
  </div>
  <div
    v-else
    class="pt-6 pb-6"
  >
    <v-alert
      class="d-inline-block"
      text
      color="red"
    >
      <v-icon
        color="red"
        class="mr-2"
      >fal fa-exclamation-triangle</v-icon>
      {{ $t('No {0}', [$t('Printer')]) }}
    </v-alert>
  </div>
</template>

<script>
import qz from '@/../own_modules/qz-tray/qz-tray'
import { getReceiptLogo, getReceiptContent, getReceiptQR } from '@/utils/receipt-layout'
import { mapState, mapGetters } from 'vuex'
import receiptService from '@/services/receipts'

export default {
  name: 'ReceiptPrinter',

  props: {
    receiptObject: {
      default: null,
      type: Object
    }
  },

  data: () => ({
    receipt: null
  }),

  computed: {
    ...mapState(['printer', 'isQzTrayInstalled']),
    ...mapGetters(['isPrinterConfigured'])
  },

  watch: {
    receiptObject: {
      immediate: true,
      handler (receiptObject) {
        this.receipt = Object.assign({}, receiptObject)
      }
    }
  },

  methods: {
    sendJobToPrinter () {
      this.$wait.start('printing receipt')
      const config = qz.configs.create(this.printer || this.defaultPrinter, {
        scaleContent: false,
        rasterize: false,
        density: '600',
        colorType: 'grayscale',
        margins: {
          right: 0.10,
          left: 0.10
        }
      })

      // Get receipt HTML
      getReceiptContent(this.receipt)
        .then(html => {
          qz.print([config, config, config], [
            getReceiptLogo(this.receipt),
            getReceiptQR(this.receipt),
            html
          ])
            .then(() => {
              receiptService.printed(this.receipt.uuid)
                .then(() => {
                  // TODO update receipt timestamp? Don't fetch the whole receipt
                  this.$emit('printed')
                  this.$wait.end('printing receipt')
                })
                .finally(() => this.$wait.end('printing receipt'))
            })
        })
        .catch(() => this.$wait.end('printing receipt'))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/receipts/ReceiptPrinter.vue